import {GroupDetailController} from './GroupDetailController';

/** @ngInject */
export class AddGroupController extends GroupDetailController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);
        this.element = {description: '', userAccounts: []};
        $scope.detailForm = {};
    }
}
